import $ from "jquery";
import "jquery-mousewheel";
import 'malihu-custom-scrollbar-plugin';

$(window).on("load", function () {
    $(".help-system__sidebar").mCustomScrollbar({
        theme: "dark",
        alwaysShowScrollbar: 1
    });
});
